import React from 'react';
import { useTranslation } from 'react-i18next';
import LegacyAccountPage from '@/components/domain/auth/LegacyAccountPage';
import { communities, isCommunityCode, type CommunityCode } from '@/constants/communities';
import { useLocalSearchParams } from 'expo-router';

export default function CommunitiesSignUp() {
  const { t } = useTranslation();
  const { community } = useLocalSearchParams<{ community?: CommunityCode }>();
  const communityCode = isCommunityCode(community) ? community : undefined;

  const helper = communityCode
    ? t('auth.signUp.redirectHelper', { communityName: communities[communityCode].name })
    : t('auth.signUp.redirectHelper', { communityName: '' });

  return (
    <LegacyAccountPage
      accountPath={'/Account/Register'}
      titleText={t('auth.createAccount')}
      webHelperText={helper}
      successText={t('auth.signUp.successToast')}
    />
  );
}
